import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
    
    constructor(private modal: NgbModal) { 

    }

    open(component:any) {
        return this.modal.open(component);
    }

    openLgModal(component: any) {
      return this.modal.open(component, {size: 'lg', scrollable: true});
    }

    openXLModal(component: any) {
      return this.modal.open(component, {size: 'xl', scrollable: true});
    }

    openWithOptions(component: any, options: NgbModalOptions) {
      return this.modal.open(component, options);
    }


}
